<template>
    <nav class="navbar is-warning" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <h1 class="title">🍗AtlHotWings</h1>
      </a>
      <!-- <span class="navbar-item">Atlanta's Premier Wing Resource</span> -->
      <a role="button" class="navbar-burger" :class="{'is-active': menuActive}" aria-label="menu" aria-expanded="false" @click="handleMenu">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="navbar-menu" :class="{'is-active': menuActive}">
      <div class="navbar-end" @click="handleMenu">
        <router-link class="navbar-item" v-for="item in menuItems" :key="item.url" :to="item.url"><i :class="'icon mdi mdi-'+item.icon"></i> {{item.title}}</router-link>
        <!-- <router-link class="navbar-item" v-if="!userIsAuthenticated" to="user/signup">Sign Up</router-link>
        <router-link class="navbar-item" v-if="!userIsAuthenticated" to="user/signin">Sign In</router-link> -->
        <a class="navbar-item" v-if="userIsAuthenticated" @click="onSignout"><i class="icon mdi mdi-exit-to-app"></i> Sign Out</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      menuActive: false
    };
  },
  computed: {
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== "undefined"
      );
    },
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    },
    menuItems() {
      let menuItems = [
        {
          title: "Deals",
          icon: "calendar",
          url: "/deals"
        }
        // {
        //   title: "Sign In",
        //   icon: "account-plus",
        //   url: "/user/signin"
        // }
      ];
      if (this.userIsAuthenticated) {
        menuItems = [
          {
            title: "Deals",
            icon: "calendar",
            url: "/deals"
          },
          {
            title: "Account",
            icon: "account-box",
            url: "/user/" + this.user.id
          }
        ];
      }
      return menuItems;
    }
  },
  methods: {
    handleMenu() {
      return (this.menuActive = !this.menuActive);
    },
    onSignout() {
      this.$store.dispatch("UserSignout");
      this.$router.push("/");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar-menu {
  background-color: #ffdd57;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue